import { render, staticRenderFns } from "./MyReport.vue?vue&type=template&id=0508468b&scoped=true"
import script from "./MyReport.vue?vue&type=script&lang=js"
export * from "./MyReport.vue?vue&type=script&lang=js"
import style0 from "./MyReport.vue?vue&type=style&index=0&id=0508468b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508468b",
  null
  
)

export default component.exports